import storeLink from "fragments/vendors/storeLink"
import gql from "graphql-tag"

const UPDATE_STORE_LINK = gql`
  ${storeLink}

  mutation updateStoreLink(
    $id: ID!
    $storeLinkUpdateInput: StoreLinkUpdateInput!
  ) {
    updateStoreLink(id: $id, storeLinkUpdateInput: $storeLinkUpdateInput) {
      ...StoreLink
    }
  }
`
export default UPDATE_STORE_LINK
